import { Component, OnInit, ViewChild } from '@angular/core';
import { CompositeFilterDescriptor, DataSourceRequestState, groupBy } from '@progress/kendo-data-query';

import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NotificationService } from '../../../core/services/notification.service';
import { AppService } from '../../../app.service';
import { User } from '../../../shared/models/User/User';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { UserRole } from '../../../shared/models/User/UserRole';
import { UserGroup } from '../../../shared/models/User/user-group';
import { EntityViewModel } from '../../../shared/models/core/EntityViewModel';
import { ComponentPageBase } from '../../../shared/components/component-page-base/component-page-base';
import { UsersService } from '../users.service';
import * as textMaskAddons from 'text-mask-addons/dist/textMaskAddons';
import { KeyValueObject } from '../../../shared/models/core/KeyValueObject';
import { LookupService } from '../../../shared/services/lookup.service';
import { AddressService } from '../../../shared/services/address.service';
import { SecurityService } from '../../../core/services/security.service';
import { EthereumGateService } from '../../../shared/services/ethereum-gate.service';
import { NotificationType } from '../../../core/services/notification-type';
import { EthereumGateComponent } from '../../../shared/components/ethereum-gate-users/ethereum-gate-users.component';
import { DialogService } from '@progress/kendo-angular-dialog';
import { DaDataAddressComponent } from '../../../shared/components/dadata-address/dadata-address.component';
import { UserGroupsService } from '../../../shared/services/user-groups.service';
import { ContragentType, RoleEnum } from '../../../shared/enums';
import { ContragentsService } from '../../../categories/contragents/contragents.service';
import { TreeDropdownListComponent } from '../../../tree-dropdown-list/components/tree-dropdownlist/tree-dropdown-list.component';
import { HierarchyLookupModel } from '../../../shared/models/core/HierarchyLookupModel';
import { PasswordOptions } from '../../../shared/models/User/password-options';
import { UserServiceCenter } from '../../../shared/models/User/user-service-center';
import { ServiceBoundary } from '../../../shared/models/User/ServiceBoundary';
import { RegionsService } from '../../../shared/services/regions.service';
import { AddressSuggestion } from '../../../shared/models/dadata-address/address-suggestion';
import { GridComponent, RemoveEvent, SaveEvent } from '@progress/kendo-angular-grid';
import { finalize } from 'rxjs/operators';
import { UserImage } from '../../../shared/models/User/userImage';
import { saveAs } from 'file-saver';
import { ActionResult } from '../../../shared/models/core/ActionResult';
import { EngubatorEngineer } from '../../../shared/models/engubator/engubator.engineer';
import { EngubatorEngineersService } from '../../../shared/services/engubator/engubator.engineers.service';
import { EngubatorSkillsService } from '../../../shared/services/engubator/engubator.skills.service';
import { EngubatorSkill } from '../../../shared/models/engubator/engubator.skill';
import { UserMarketPlace } from '../../../shared/models/User/user-market-place';
import { UserRequestCategoryDto } from '../../../shared/models/User/user-request-category.dto';

const flatten = filter => {
	const filters = filter.filters;
	if (filters) {
		return filters.reduce((acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
	}
	return [];
};


@Component({
	selector: 'admin-user',
	templateUrl: './user.page.html',
	styleUrls: [
		'./user.page.scss',
		'../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
		'../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../vendor/libs/ngx-contextmenu/ngx-contextmenu.scss',
	]
})
export class UserPage extends ComponentPageBase<User> implements OnInit {

	@ViewChild("rolesGrid") public rolesGrid: GridComponent;
	@ViewChild("userGroupsGrid") public userGroupsGrid: GridComponent;
	@ViewChild("serviceCentersGrid") public serviceCentersGrid: GridComponent;
	@ViewChild("userMarketPlacesGrid") public userMarketPlacesGrid: GridComponent;
	@ViewChild("userRequestCategoriesGrid") public userRequestCategoriesGrid: GridComponent;
	@ViewChild("daDataAddressControl") public daDataAddressControl: DaDataAddressComponent;
	@ViewChild("userGroupsTreeDropdownList") public userGroupsTreeDropdownList: TreeDropdownListComponent;

	private readonly userGroupsControllerName: string = 'user-groups';

	private isUsedUserGroupsList: boolean = false;

	emailMaskOptions = {
		mask: textMaskAddons.emailMask
	};

	cellPhoneMask: string = "+7 (000) 000-00-00";
	public rules: { [key: string]: RegExp } = {
		'0': /\d/
	};
	serviceCenters: KeyValueObject[] = [];
	contragents: KeyValueObject[] = [];
	districts: KeyValueObject[] = [];
	districtsGrouped: any[] = [];
	clients: KeyValueObject[] = [];
	agreements: KeyValueObject[] = [];
	regions: KeyValueObject[] = [];
	filteredRegions: KeyValueObject[] = [];
	skills: EngubatorSkill[] = [];
	requestTypes: KeyValueObject[] = [];
	requestCategories: KeyValueObject[] = [];
	requestCategoriesDropdownData: KeyValueObject[] = [];
	marketPlaces: KeyValueObject[] = [];
	marketPlacesDropdownData: KeyValueObject[] = [];

	loadingSkills: boolean = false;
	chooseAllServiceCenters: boolean = false;
	chooseAllClients: boolean = false;
	loading: boolean = false;
	otpTokenGenerating: boolean = false;
	isAssigningBlockedProcessing: boolean = false;
	passswordOptions: PasswordOptions = new PasswordOptions();
	engineerRoles = [RoleEnum.master, RoleEnum.specialist];

	userMovementTypes: KeyValueObject[] = [];

	public engubatorViewModel?: EntityViewModel<EngubatorEngineer>;

	private roleFilterValueSubject: Subject<string> = new Subject();
	public rolesToAddDefaultItem: { name: string, roleId: number } = { name: 'Выберите роль...', roleId: null };
	public roleToAdd: { name: string, roleId: number } = this.rolesToAddDefaultItem;
	public roles: KeyValueObject[] = [];

	public warehouseDepotAddresses: KeyValueObject[] = [];

	private _depotStartAddressIdBeforeDropdownChange: number | null = null;

	private lastNewGroup: UserGroup = null;
	public userGroupsHierarchyLookupModels: HierarchyLookupModel[] = [];

	public dropDownVirtualSettings: any = {
		itemHeight: 28
	};

	public rolesState: DataSourceRequestState = {
		skip: 0,
		take: 100000,
		sort: [{ field: 'name', dir: 'asc' }],
		filter: {
			logic: 'and',
			filters: [
			]
		}
	};

	constructor(
		protected route: ActivatedRoute,
		protected router: Router,
		protected appService: AppService,
		protected notificationService: NotificationService,
		private lookupService: LookupService,
		private addressService: AddressService,
		private contragentsService: ContragentsService,
		private securityService: SecurityService,
		protected dataService: UsersService,
		private ethereumGateService: EthereumGateService,
		protected dialogService: DialogService,
		private userGroupService: UserGroupsService,
		private regionsService: RegionsService,
		private engubatorEngineersService: EngubatorEngineersService,
		private engubatorSkillsService: EngubatorSkillsService
	) {
		super(route, router, appService, notificationService, dataService);
		this.listPageRoutePath = 'admin/users';
		this.appService.pageTitle = 'Новый пользователь';
	}

	public requestTypesSkillsData(): string[] {
		const compositionRequestTypes = this.engubatorViewModel.entity.skills
			.filter(x => x.composition)
			.map(x => x.composition)
			.reduce((a, b) => a.concat(b), [])
			.map(x => x.requestTypeId);

		return this.requestTypes.filter(
			f => compositionRequestTypes.includes(f.id)
		).map(m => m.name);
	}

	public requestCategoriesSkillsData(): string[] {
		const compositionDeviceModels = this.engubatorViewModel.entity.skills
			.filter(x => x.composition)
			.map(x => x.composition)
			.reduce((a, b) => a.concat(b), [])
			.map(x => x.requestCategoryId);

		return this.requestCategories.filter(
			f => compositionDeviceModels.includes(f.id)
		).map(m => m.name);
	}

	get saveUserChangesDisabled(): boolean {
		return this.entityForm.pristine || !this.entityForm.valid
		|| (this.userIsEngineer && (!this.entityViewModel.entity.userMovementTypeId || this.entityViewModel.entity.userMovementTypeId === 0))
		|| !this.isYandexDepotRouteValid;
	}

	get isYandexDepotRouteValid(): boolean {
		if (!this.userIsEngineer) {
			return true;
		}
		const e = this.entityViewModel.entity;
		if (e.visitDepotAtStart && e.startingDepotAddressId == null) {
			return false;
		}
		if (e.returnToDepot && e.endingDepotAddressId == null) {
			return false;
		}
		return true;
	}

	createNewUserGroup(): UserGroup {
		let userGroup = new UserGroup();
		userGroup.isDefaultGroup = this.entityViewModel.entity.userGroups
			.filter(x => x.isDefaultGroup).length === 0;

		return userGroup;
	}

	addNewUserGroup() {
		this.userGroupsGrid.addRow(this.createNewUserGroup());
		this.onAddNewGroupRow();
	}

	createNewServiceCenter(): UserServiceCenter {
		let userServiceCenter = new UserServiceCenter();
		userServiceCenter.isDefault = !this.entityViewModel.entity.userServiceCenters.some(x => x.isDefault);

		return userServiceCenter;
	}

	addNewServiceCenter() {
		this.serviceCentersGrid.addRow(this.createNewServiceCenter());
	}

	createNewUserMarketPlace(): UserMarketPlace {
		let userMarketPlace = new UserMarketPlace();

		return userMarketPlace;
	}

	addNewUserMarketPlace() {
		this.userMarketPlacesGrid.addRow(this.createNewUserMarketPlace());
	}

	handleOpenMarketPlaceDropdown(marketPlaceId: number) {
		let selectedDeviceMarketPlaceIds = this.entityViewModel.entity.userMarketPlaces.filter(x =>
			x.deviceMarketPlaceId != marketPlaceId).map(x => x.deviceMarketPlaceId);
		this.marketPlacesDropdownData = this.marketPlaces.filter(x =>
			!selectedDeviceMarketPlaceIds.some(s => s == x.id))
	}

	createNewUserRequestCategory(): UserRequestCategoryDto {
		let userRequestCategory = new UserRequestCategoryDto();
		return userRequestCategory;
	}

	addNewUserRequestCategory() {
		this.userRequestCategoriesGrid.addRow(this.createNewUserRequestCategory());
	}

	handleOpenRequestCategoryDropdown(requestCategoryId: number) {
		let selectedRequestDeviceIds = this.entityViewModel.entity.userRequestCategories.filter(x =>
			x.requestCategoryId != requestCategoryId).map(x => x.requestCategoryId);
		this.requestCategoriesDropdownData = this.requestCategories.filter(x =>
			!selectedRequestDeviceIds.some(s => s == x.id));
	}

	get createNewServiceBoundary(): any {
		return function () {
			return new ServiceBoundary();
		};
	}

	get passwordOptionsText(): string {
		let text = '';
		if (this.passswordOptions.requireUppercase) {
			text += ', {A-Z}';
		}
		if (this.passswordOptions.requireLowercase) {
			text += ', {a-z}';
		}
		if (this.passswordOptions.requireDigit) {
			text += ', {0-9}';
		}
		if (this.passswordOptions.requireNonAlphanumeric) {
			text += ', {!@#$%^&*()_+:><~}';
		}
		if (text.length > 0) {
			text = ' и содержать минимум 1 символ из каждой группы:' + text.substring(2);
		}
		return `Пароль должен быть не менее ${this.passswordOptions.requiredLength} символов${text}.`;
	}

	ngOnInit() {
		this.addressService.getDepotAddressesLookup().subscribe(data => {
			this.warehouseDepotAddresses = data;
		});
		this.entityId = this.route.snapshot.paramMap.get('userId');

		this.loadServiceCenters();

		this.contragentsService.lookupAllList([]).subscribe(data => {
			this.contragents = data;

			if (this.contragents.length > 0 && this.isNew && !this.entityViewModel.entity.contragentId) {
				const contragentId = this.contragents[0].id;
				this.loadUserGroupsBySelectedContragent(contragentId);
			}
		});

		this.dataService.getPasswordOptions().subscribe(d => {
			this.passswordOptions = d;
		});

		this.lookupService.getData("user-movement-types", null).subscribe(res => {
			this.userMovementTypes = res;
		});

		if (this.entityId != null) {

			this.dataService.getById(+this.entityId).subscribe(vm => {
				vm.entity.userGroups = vm.entity.userGroups.sort((a, b) => a.name.localeCompare(b.name));
				this.loadEngubatorData(vm.entity.integraCode);

				this.lookupService.getData('device-market-places', null).subscribe(resp => {
					this.marketPlaces = resp;
					this.marketPlacesDropdownData = resp;
				});

				this.entityName = `${vm.entity.surname} ${vm.entity.name} ${vm.entity.middleName}`;
				this.dataBind(vm);
				this.syncDepotAddressDropdownSnapshot();
				if (vm.entity.userImage == undefined) {
					vm.entity.userImage = new UserImage();
				}

				this.loadClients();

				this.loadUserGroupsBySelectedContragent(vm.entity.contragentId);

				if (this.clients.length == 0) {
					this.chooseAllClients = true;
				}
				setTimeout(() => {
					if (this.daDataAddressControl) {
						this.daDataAddressControl.initValue(this.entityViewModel.entity.fullAddress);
					}
				}, 1000);
			});
			if (this.clients.length == 0) {
				this.chooseAllClients = true;
			}

		} else {

			this.entityViewModel = new EntityViewModel<User>();
			this.entityViewModel.entity = new User();
			this.entityViewModel.entity.createdDate = new Date();
			if (this.entityViewModel.entity.contragentId !== this.securityService.currentUser.contragentId) {
				this.entityViewModel.entity.contragentId = this.securityService.currentUser.contragentId;
				this.loadUserGroupsBySelectedContragent(this.entityViewModel.entity.contragentId);
			}
			this.canEditForm = true;
			this.isNew = true;
			this.syncDepotAddressDropdownSnapshot();
		}

		this.roleFilter('');

		this.roleFilterValueSubject.pipe(debounceTime(400)).subscribe(value => {
			this.roleFilter(value);
		});
	}

	private loadEngubatorData(integraCode?: string): void {
		this.loadingSkills = true;
		if (integraCode)
			this.engubatorEngineersService.getById(integraCode).subscribe(vm => {
				this.engubatorViewModel = vm;
			})
		else {
			this.engubatorViewModel = new EntityViewModel<EngubatorEngineer>();
			this.engubatorViewModel.entity = new EngubatorEngineer();
			this.entityViewModel.entity.isEngineer = true;
			this.engubatorViewModel.isNew = true;
		}

		this.engubatorSkillsService.list('includeComposition=true')
			.pipe(finalize(() => this.loadingSkills = false))
			.subscribe(result => this.skills = result.data);
		this.lookupService.getData("request-types", null).subscribe(data => this.requestTypes = data);
		this.lookupService.getData("request-categories", null).subscribe(data => {
			this.requestCategories = data;
			this.requestCategoriesDropdownData = data;
		});
	}

	loadUserGroupsBySelectedContragent(contragentId: number): void {
		const requestState: DataSourceRequestState = {
			filter: {
				logic: 'and',
				filters: [
					{
						logic: 'or',
						filters: [
							{ field: 'ContragentId', operator: 'eq', value: contragentId },
							{ field: 'ContragentId', operator: 'isnull' }
						]
					},
					{ field: 'IsVisible', operator: 'eq', value: true },
				]
			}
		};
		this.userGroupsHierarchyLookupModels = [];
		this.lookupService.getHierarchyData(this.userGroupsControllerName, requestState)
			.subscribe(data => this.userGroupsHierarchyLookupModels = data);
	}

	loadServiceCenters(callback: () => void = null): void {
		const requestState: DataSourceRequestState = {
			filter: {
				logic: 'and',
				filters: [
					{ field: 'ContragentTypeId', operator: 'eq', value: ContragentType.serviceCenter }
				]
			}
		};

		this.lookupService.getData("service-centers", requestState)
			.subscribe(data => {
				this.serviceCenters = data;

				if (callback) {
					callback();
				}
			});
	}

	handleFilter(value) {
		var filtered = this.districts.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
		this.districtsGrouped = groupBy(filtered, [{ field: "groupName" }]);
	}

	onAddressChange(value: AddressSuggestion) {
		if (this.entityViewModel.entity.fullAddress !== value.address) {
			this.appService.MarkFormDirty(this.entityForm);
		}

		this.entityViewModel.entity.fullAddress = value.address;
	}

	onDepotStartDropdownFocus(): void {
		this._depotStartAddressIdBeforeDropdownChange = this.entityViewModel.entity.startingDepotAddressId;
	}

	onStartingDepotAddressDropdownChange(): void {
		const e = this.entityViewModel.entity;
		const prev = this._depotStartAddressIdBeforeDropdownChange;
		this.appService.MarkFormDirty(this.entityForm);
		if (e.returnToDepot) {
			const end = e.endingDepotAddressId;
			if (end == null || (prev != null && end === prev)) {
				e.endingDepotAddressId = e.startingDepotAddressId;
			}
		}
		this._depotStartAddressIdBeforeDropdownChange = e.startingDepotAddressId;
	}

	onEndingDepotAddressDropdownChange(): void {
		this.appService.MarkFormDirty(this.entityForm);
	}

	onVisitDepotAtStartChange(): void {
		this.appService.MarkFormDirty(this.entityForm);
		const e = this.entityViewModel.entity;
		if (!e.visitDepotAtStart) {
			e.startingDepotAddressId = null;
		} else if (e.returnToDepot) {
			e.endingDepotAddressId = e.startingDepotAddressId;
		}
		this._depotStartAddressIdBeforeDropdownChange = e.startingDepotAddressId;
	}

	onReturnToDepotChange(): void {
		this.appService.MarkFormDirty(this.entityForm);
		const e = this.entityViewModel.entity;
		if (!e.returnToDepot) {
			e.endingDepotAddressId = null;
		} else if (e.visitDepotAtStart) {
			e.endingDepotAddressId = e.startingDepotAddressId;
		}
		this._depotStartAddressIdBeforeDropdownChange = e.startingDepotAddressId;
	}

	onContragentChange(contragentId: number): void {
		this.loadUserGroupsBySelectedContragent(contragentId);
		this.entityViewModel.entity.userGroups = [];
	}

	onChangeDefaultUserGroup(userGroup: UserGroup): void {
		const userGroups = this.entityViewModel.entity.userGroups;
		if (!userGroup.userGroupId && !userGroups.includes(userGroup)) {
			this.lastNewGroup = userGroup;
		}

		this.entityViewModel.entity.userGroups.forEach(group => {
			if (group !== userGroup) {
				group.isDefaultGroup = false;
			}
		});

		if (this.lastNewGroup !== userGroup) {
			this.lastNewGroup.isDefaultGroup = false;
		}
	}

	onChangeDefaultUserServiceCenter(userServiceCenter: UserServiceCenter): void {
		this.entityViewModel.entity.userServiceCenters.forEach(serviceCenter => {
			serviceCenter.isDefault = serviceCenter === userServiceCenter;
		});
	}

	onCancelEditingUserGroup(dataItem: UserGroup): void {
		dataItem.isDefaultUserForGroup = dataItem.isDefaultUserForGroupPrevious;
	}

	onChangedUserGroupId(userGroupId: number, userGroup: UserGroup): void {
		if (!userGroupId) {
			userGroup.newUserGroupId = null;
		}

		if (this.isDuplicateGroup(userGroup)) {
			userGroup.newUserGroupId = userGroup.previousGroupId;
			return;
		}

		userGroup.isDefaultUserForGroupPrevious = userGroup.isDefaultUserForGroup;
		if (userGroupId && userGroup.previousGroupId !== userGroup.newUserGroupId) {
			userGroup.isDefaultUserForGroup = false;
		}

		userGroup.previousGroupId = userGroup.newUserGroupId;
	}

	onAddNewGroupRow(): void {
		this.isUsedUserGroupsList = false;
	}

	onSaveServiceCenter(dataItem: UserServiceCenter): void {
		if (!dataItem.serviceCenterName) {
			dataItem.serviceCenterName = this.getServiceCenterName(dataItem);
		}

		if (!dataItem.integraCode) {
			let sc = this.serviceCenters.find(sc => sc.id === dataItem.serviceCenterId)
			if (!!sc)
				dataItem.integraCode = sc.integraCode
		}
	}

	onUserGroupsFormFocus(event: any): void {
		if (this.isUsedUserGroupsList) {
			event.target.focus();
		} else {
			event.target.blur();
			this.isUsedUserGroupsList = true;
		}
	}

	isStorekeeper(): boolean {
		return this.entityViewModel.entity.userRoles.some(x => x.roleId === <number>RoleEnum.storekeeper);
	}

	handleRoleFilter(value) {
		this.roleFilterValueSubject.next(value);
	}

	createNewRole(): UserRole {
		var role = new UserRole();
		return role;
	}

	addNewRole() {
		this.rolesGrid.addRow(this.createNewRole());
	}

	roleFilter(value: string) {

		this.rolesState.filter.filters = [];

		if (value !== '') {
			this.rolesState.filter.filters.push({
				field: 'Name',
				operator: 'contains',
				value: value,
				ignoreCase: true
			});
		}

		this.lookupService.getData('roles', this.rolesState)
			.subscribe(data => this.roles = data);
	}

	switchUser(): void {
		const user = this.entityViewModel.entity;
		this.securityService.login({ login: user.login, password: null, switchRequest: true })
			.subscribe(res => {
				this.loading = false;
				window.open('/requests', '_self');
			}, x => {
				this.loading = false;
			});
	}

	public cellClick({ sender, columnIndex, rowIndex, dataItem }: any): void {

		if (!this.canEditForm || columnIndex > 0) {
			return;
		}

		sender.editRow(rowIndex);

	}

	public saveHandler(event: SaveEvent) {
		this.appService.MarkFormDirty(this.entityForm);

		if (event.dataItem.roleId) {
			if (this.entityViewModel.entity.userRoles.some(s => s.roleId == event.dataItem.roleId)) {
				event.dataItem = null;
				this.notificationService.warning({ title: 'Повтор', message: 'Данная роль уже выбрана', notificationType: NotificationType.Toast });
				return;
			}

			this.entityViewModel.entity.isEngineer = this.engineerRoles.includes(event.dataItem.roleId)
				|| this.entityViewModel.entity.userRoles.some(s => this.engineerRoles.includes(s.roleId));
		}
	}

	public removeHandler(event: RemoveEvent) {
		this.appService.MarkFormDirty(this.entityForm);

		if (event.dataItem.contragentId) {
			this.chooseAllClients = false;
		}
		if (event.dataItem.roleId) {
			if (this.engineerRoles.includes(event.dataItem.roleId) && !this.entityViewModel.entity.userRoles.filter(f => f.roleId != event.dataItem.roleId).some(s => this.engineerRoles.includes(s.roleId))) {
				this.entityViewModel.entity.isEngineer = false;
			}
			if (event.dataItem.roleId == RoleEnum.selfEmployedEngineer) {
				this.entityViewModel.entity.isSelfEmployed = false;
			}
		}
	}


	getRoleName(roleId: number) {
		const filtered = this.roles.filter(x => x.id === roleId);

		if (filtered.length === 0) {
			return '';
		}

		return filtered[0].name;
	}

	getGroupName(userGroup: UserGroup): string {
		const userGroupId = userGroup.newUserGroupId ? userGroup.newUserGroupId : userGroup.userGroupId;
		const userGroups = this.userGroupsHierarchyLookupModels.filter(x => x.id === userGroupId);
		if (userGroups.length > 0 && !userGroups[0].name) {
			const allGroups = userGroups.filter(x => x.id === userGroupId);
			return allGroups.length === 0 ? '' : allGroups[0].name;
		}

		return userGroups.length === 0 ? userGroup.name : userGroups[0].name;
	}

	getServiceCenterName(dataItem: UserServiceCenter): string {
		const filteredServiceCenters = this.serviceCenters.filter(x => x.id === dataItem.serviceCenterId);
		return filteredServiceCenters[0].name;
	}

	public onClickChooseAllServiceCenters(): void {

		this.chooseAllServiceCenters = !this.chooseAllServiceCenters;

		if (this.chooseAllServiceCenters) {
			this.entityViewModel.entity.userServiceCenters = this.serviceCenters.map(x => {
				const userServiceCenter = { serviceCenterId: x.id, serviceCenterName: x.name } as UserServiceCenter;
				return userServiceCenter;
			});
		} else {
			this.entityViewModel.entity.userServiceCenters = [];
		}
	}

	askSetPerformerUserGroup(userGroup: UserGroup) {
		if (!userGroup.newUserGroupId) {
			userGroup.isDefaultUserForGroup = false;
			return;
		}

		if (userGroup.isDefaultUserForGroup) {
			return;
		}

		const currentUserName = this.entityViewModel.entity.displayName;
		const currentUserId = this.entityViewModel.entity.userId;
		this.userGroupService.getPerformerUserByGroup(userGroup.newUserGroupId).subscribe(res => {
			if (res.hasDefaultUser) {
				this.notificationService.confirmation({
					title: this.entityName,
					message: `Для группы ${res.groupName} уже имеется ответственный сотрудник: ${res.userName}.
					Хотите заменить его на ${currentUserName ? currentUserName : ''} (${currentUserId ? currentUserId : 'текущий'})?`,
					type: 'question',
					confirmButtonText: 'Да',
					cancelButtonText: 'Отмена',
					showCloseButton: true
				}, () => {
					userGroup.isDefaultUserForGroup = true;
				}, () => {
					userGroup.isDefaultUserForGroup = false;
				});
			}
		});
	}

	public saveUserChanges(): void {
		this.saveChanges(this.entityName);
	}

	beforeSaveChanges(): void {
		const e = this.entityViewModel.entity;
		if (!this.userIsEngineer) {
			e.visitDepotAtStart = false;
			e.returnToDepot = false;
			e.startingDepotAddressId = null;
			e.endingDepotAddressId = null;
			return;
		}
	}

	isDuplicateGroup(userGroup: UserGroup): boolean {
		if (!userGroup.newUserGroupId) {
			return false;
		}

		const isExist = this.entityViewModel.entity.userGroups
			.some(((group, index, _) => group !== userGroup &&
				(group.userGroupId === userGroup.newUserGroupId || group.newUserGroupId === userGroup.newUserGroupId)) as any);
		if (isExist) {
			this.notificationService.error({
				title: 'Ошибка валидации',
				message: 'Выбранная группа уже есть в вашем списке.',
				notificationType: NotificationType.SweetAlert
			});
		}

		return isExist;
	}

	private syncDepotAddressDropdownSnapshot(): void {
		const e = this.entityViewModel && this.entityViewModel.entity;
		if (!e) {
			return;
		}
		this._depotStartAddressIdBeforeDropdownChange = e.startingDepotAddressId;
	}

	private async loadClients(): Promise<void> {
		const response = await this.contragentsService.lookupAllList([1]).toPromise();
		if (this.entityViewModel.entity != null && this.entityViewModel.entity.serviceBoundaries != null
			&& this.entityViewModel.entity.serviceBoundaries.length > 0) {
			var addedClientIds = this.entityViewModel.entity.serviceBoundaries
				.filter(val => val.agreementId == null && val.regionId == null).map(val => val.contragentId);
			this.clients = response.filter(val => !addedClientIds.includes(val.id));
		}
		else {
			this.clients = response;
		}
	}

	public async onClickChooseAllClients(): Promise<void> {
		this.chooseAllClients = !this.chooseAllClients;
		this.entityViewModel.entity.serviceBoundaries = [];
		if (this.chooseAllClients) {
			await this.loadClients();
			this.entityViewModel.entity.serviceBoundaries = this.clients.map(val => {
				const sb = { contragentId: val.id } as ServiceBoundary;
				return sb;
			});
		}
	}

	public regionsDDL_handleFilter(value: string) {
		this.filteredRegions = this.regions.filter(r => r.name.toLowerCase().indexOf(value.toLowerCase()) != -1);
	}

	get userIsEngineer(): boolean {
		return this.entityViewModel.entity.userRoles.some(x => this.engineerRoles.some(r => r == x.roleId));
	}

	get hasEngubatorEntity(): boolean {
		return this.engubatorViewModel != null && this.engubatorViewModel.entity != null &&
			this.entityViewModel.entity.integraCode != null &&
			this.engubatorViewModel.entity.integraCode != null &&
			this.entityViewModel.entity.integraCode.toLowerCase() == this.engubatorViewModel.entity.integraCode.toLowerCase();
	}

	get showSkillAlert(): boolean {
		return this.userIsEngineer && !this.hasEngubatorEntity;
	}

	get skillAlertText(): string {
		if ((this.userIsEngineer && this.isNew) ||
			(this.userIsEngineer && !this.hasEngubatorEntity && this.canEditForm)) {
			return 'Сохраните инженерную роль пользователя для редактирования';
		}
		else {
			return 'Данные не получены';
		}
	}

	afterSaveChanges() {
		if (this.entityViewModel.entity.userId == null || this.entityViewModel.entity.userId == 0) {
			super.afterSaveChanges();
			return;
		}

		this.dataSaving = true;

		this.dataService.getById(this.entityViewModel.entity.userId).subscribe(vm => {
			vm.entity.userGroups = vm.entity.userGroups.sort((a, b) => a.name.localeCompare(b.name));
			this.entityName = `${vm.entity.surname} ${vm.entity.name} ${vm.entity.middleName}`;
			this.dataBind(vm);
			this.syncDepotAddressDropdownSnapshot();
			setTimeout(() => {
				if (this.daDataAddressControl) {
					this.daDataAddressControl.initValue(this.entityViewModel.entity.fullAddress);
				}
			}, 1000);

			if (this.userIsEngineer && this.hasEngubatorEntity) {
				if (this.entityViewModel.entity.integraCode) {
					let serviceCentersIntegraCodes = this.entityViewModel.entity.userServiceCenters.map(m => m.integraCode);
					this.engubatorViewModel.entity.serviceCenters = serviceCentersIntegraCodes;
					this.engubatorViewModel.entity.movementTypeId = this.entityViewModel.entity.userMovementTypeId;
					this.engubatorEngineersService.update(this.engubatorViewModel.entity, null, false, true, `/${this.entityViewModel.entity.integraCode}`).subscribe(() => {
						this.loadingSkills = true;
						this.engubatorSkillsService.list('includeComposition=true')
							.pipe(finalize(() => this.loadingSkills = false))
							.subscribe(result => this.skills = result.data);
						this.engubatorEngineersService.getById(this.entityViewModel.entity.integraCode).subscribe(vm => {
							this.engubatorViewModel = vm;
							this.dataSaving = false;
						}, () => { this.dataSaving = false; });
					}, () => { this.dataSaving = false; });
				} else {
					this.dataService.getById(this.entityId).subscribe(result => {
						this.dataBind(result);
						this.syncDepotAddressDropdownSnapshot();
						this.dataSaving = false;
					}, () => { this.dataSaving = false; });
				}
			}
			else if (this.entityViewModel.entity.integraCode) {
				this.engubatorEngineersService.getById(this.entityViewModel.entity.integraCode).subscribe(vm => {
					this.engubatorViewModel = vm;
					this.dataSaving = false;
				}, () => { this.dataSaving = false; });
			}
			else {
				this.dataSaving = false;
			}
		});

		super.afterSaveChanges();
	}

	generateOtpToken() {
		this.notificationService.confirmation({
			title: 'Подтвердите действие',
			message: 'Вы уверены, что хотите изменить OTP-токен для этого пользователя? Старый OTP-токен пользователя будет отменен',
			confirmButtonText: 'Подтвердить',
			cancelButtonText: 'Отменить'
		}, () => { this.generateOtpTokenCore() });
	}

	generateOtpTokenCore() {
		this.otpTokenGenerating = true;
		this.securityService.generateOtpToken(this.entityViewModel.entity.userId).subscribe((resp) => {
			if (!resp.isSuccessful) {
				this.notificationService.error({
					title: 'Ошибка генерации OTP-токена',
					message: resp.errorDescription
				});
			}
			else {
				this.notificationService.success({
					title: 'OTP-токен успешно сгенерирован'
				});
				this.entityViewModel.entity.hasOtpToken = true;
			}

			this.otpTokenGenerating = false;
		}, () => this.otpTokenGenerating = false);
	}

	sendOtpTokenToUser() {
		// TODO: временное решение!! потом просто вызов (под капотом отправит в телегу)
		this.securityService.sendOtpTokenToUser(this.entityViewModel.entity.userId).subscribe(blob => {
			if (blob.errorDescription) {
				this.notificationService.error({
					title: 'Ошибка отправки OTP-токена',
					message: blob.errorDescription
				});
			}
			else {
				saveAs(blob, `user_${this.entityViewModel.entity.userId}_opt_qr_code.png`, { type: 'application/octet-stream' });
			}
		});
	}

	get defaultCardHeight(): number {
		return window.innerHeight / 2.5;
	}

	getNameById(data: KeyValueObject[], id: number): string {
		return this.appService.getNameById(data, id);
	}
}
